module.exports = require("node-uuid");


//////////////////
// WEBPACK FOOTER
// external "node-uuid"
// module id = 9
// module chunks = 0